import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { legalDoc, legalFor, OWNER } from "../lib/legal";
import { CookieBanner } from "../components/CookieBanner";

export default function Legal({ kind }) {
  const lang = localStorage.getItem("drnova_lang") || (navigator.language || "it").slice(0, 2);
  const doc = legalDoc(lang, kind);
  const u = legalFor(lang).ui;
  return (
    <div className="min-h-screen bg-[#f4f6f5] px-5 py-10 text-slate-800" data-testid={`legal-page-${kind}`}>
      <article className="mx-auto max-w-2xl">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-teal-700 hover:underline" data-testid="legal-back-link"><ArrowLeft size={16} />{u.back}</Link>
        <h1 className="font-display mt-6 text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl" data-testid="legal-title">{doc.title}</h1>
        <p className="mt-2 text-xs text-slate-500">{u.updated}: {OWNER.updated}</p>
        {doc.sections.map(([h, p]) => (
          <section key={h} className="mt-8">
            <h2 className="font-display text-base font-bold text-slate-900 md:text-lg">{h}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{p}</p>
          </section>
        ))}
        <p className="mt-10 flex gap-3 text-sm">
          <Link to={kind === "privacy" ? "/cookie" : "/privacy"} className="text-teal-700 hover:underline" data-testid="legal-other-link">{kind === "privacy" ? u.cookie : u.privacy}</Link>
        </p>
      </article>
      <CookieBanner lang={lang} />
    </div>
  );
}
